import type { InferContractRouterOutputs } from '@orpc/contract'

import { formatUnits } from 'viem'

import type { Contract } from '@/lib/orpc/contracts'

import { formatTimeseriesData } from '@/components/charts/helpers/highcharts'

import type { VaultHistoryMode } from './hooks/useCurrencyMode'

type TotalAssetsHistoryPoint =
  InferContractRouterOutputs<Contract>['vaultV2']['totalAssetsHistory']['points'][number]

/**
 * The chart's `[ms, value]` series: USD as returned, asset amounts in whole units. Without the
 * asset decimals the asset amounts can't be read, so their points are empty.
 */
export function toTotalDepositChartData(
  points: TotalAssetsHistoryPoint[],
  dataMode: VaultHistoryMode,
  assetDecimals: number | null
): [number, number | null][] {
  return formatTimeseriesData(
    points.map(point => ({
      x: point.timestamp,
      y:
        dataMode === 'totalAssetsUsd'
          ? point.totalAssetsUsd
          : assetDecimals === null
            ? null
            : Number(formatUnits(BigInt(point.totalAssets), assetDecimals))
    }))
  )
}

/** Points without a single value: the chart shows its error state rather than an empty plot. */
export function hasNoChartValues(data: [number, number | null][]): boolean {
  return data.length > 0 && data.every(([, value]) => value === null)
}
